import type { WazuhPagedData } from 'src/types/mindtime/wazuhDashboard';

export const previewPaged = <T>(
  items: T[],
  page = 0,
  pageSize = Math.max(items.length, 1),
): WazuhPagedData<T> => ({
  items,
  page,
  pageSize,
  totalRecords: items.length,
  totalPages: Math.max(1, Math.ceil(items.length / pageSize)),
});
